import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import AddTaskPriceModal from './AddTaskPriceModal'
import { deleteAdminPlanAction } from '../../../Redux/Actions/AdminUserActivity'
import { IoCalendarClearOutline } from 'react-icons/io5'
import { MdOutlineEdit } from 'react-icons/md'
import { FaSpinner } from 'react-icons/fa'
import { RiDeleteBinLine } from 'react-icons/ri'

const TaskRow = ({ curElem, loader, setLoader, fetchData }) => {
    const dispatch = useDispatch()
    const [id, setId] = useState('')
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleDelete = () => {
        setId(curElem.id)
        setLoader({
            ...loader,
            delete: true
        })
        let data = {
            id: curElem.id
        }
        dispatch(deleteAdminPlanAction("delete-tasktype", data, loader, setLoader, fetchData))
    }
    return (
        <>
            <tr >
                <td data-label="S.No">{curElem.id}</td>
                <td data-label="Name">{curElem.name}</td>
                <td data-label="Price">{curElem.price}</td>
                <td data-label="User Price">{curElem.userPrice}</td>
                <td data-label="Created Date"><IoCalendarClearOutline style={{ marginRight: "3px", marginTop: "-2px", marginLeft: "auto" }} />{curElem.created}</td>
                <td data-label="Action">
                    <div className="table-btns d-flex align-items-center gap-2 mt-2 mt-md-0">
                        <span className="table-edit" onClick={() => setShow(true)}><MdOutlineEdit />
                        </span>
                        <span className="table-delete" onClick={handleDelete}>
                            {curElem.id === id ? loader.delete ? <FaSpinner style={{ fontSize: "18px" }} className="spin ms-1" /> : null : <RiDeleteBinLine />}
                        </span>
                    </div>
                </td>
            </tr>
            <AddTaskPriceModal show={show} handleClose={handleClose} loader={loader} setLoader={setLoader} fetchData={fetchData} curElem={curElem} />

        </>
    )
}

export default TaskRow